const burger = document.querySelector('.burger');
const header = document.querySelector('.header');
const overlay = document.querySelector('.overlay');
const menu = document.querySelector('#header-nav');
const closeBtn = document.querySelector('.burger-close-btn');

function toggleMenu() {
    menu.classList.toggle('shown');
    overlay.classList.toggle('shown');
    header.classList.toggle('header_fixed');
}

export default function burgerToggler (){
burger.addEventListener('click', toggleMenu);
overlay.addEventListener('click', toggleMenu);
closeBtn.addEventListener('click', toggleMenu);
menu.onclick = function (event) {
  if (event.target.tagName === "LI" || event.target.tagName === "A") {
    if(menu.classList.contains('shown')){
        toggleMenu();
    }
  }
}
}